import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import CollectionPageJsonLd from '@/components/feature/CollectionPageJsonLd';

const allArticles = [
  {
    slug: '/artigo/guia-completo-hoobuyspreadsheet',
    tag: 'Guia Completo',
    title: 'Guia Completo do HoobuySpreadsheet 2026: Como Comprar com Segurança e Economizar',
    excerpt: 'Descubra como usar o Hoobuy Spreadsheet para encontrar os melhores produtos, comparar preços automaticamente e comprar com segurança em 2026.',
    imageUrl: 'https://readdy.ai/api/search-image?query=Modern%20workspace%20with%20laptop%20displaying%20spreadsheet%2C%20clean%20cream%20background%2C%20soft%20natural%20lighting%2C%20minimalist%20office%20scene%2C%20warm%20neutral%20tones%2C%20editorial%20photography%2C%20peaceful%20composition&width=800&height=500&seq=gdc-guia-completo&orientation=landscape'
  },
  {
    slug: '/artigo/como-economizar-compras-online',
    tag: 'Dicas de Economia',
    title: 'Como Economizar com o HoobuySpreadsheet: Estratégias que Realmente Funcionam',
    excerpt: 'Aprenda as melhores estratégias para economizar dinheiro usando o Hoobuy Spreadsheet. Comparação de preços e compras inteligentes.',
    imageUrl: 'https://readdy.ai/api/search-image?query=Open%20spreadsheet%20on%20laptop%20with%20coffee%20and%20notebook%2C%20savings%20concept%2C%20warm%20morning%20light%2C%20organized%20desk%2C%20productive%20atmosphere%2C%20minimal%20workspace&width=800&height=500&seq=gdc-economizar&orientation=landscape'
  },
  {
    slug: '/artigo/hoobuyspreadsheet-vs-concorrentes',
    tag: 'Comparativo',
    title: 'HoobuySpreadsheet vs Concorrentes: Qual a Melhor Ferramenta para Compras Online?',
    excerpt: 'Comparação detalhada entre o Hoobuy Spreadsheet e outras ferramentas. Entenda por que o HoobuySpreadsheet é a escolha número um.',
    imageUrl: 'https://readdy.ai/api/search-image?query=Two%20laptops%20side%20by%20side%20showing%20different%20spreadsheets%2C%20comparison%20concept%2C%20clean%20office%20desk%2C%20bright%20modern%20workspace%2C%20editorial%20photography&width=800&height=500&seq=gdc-vs-concorrentes&orientation=landscape'
  },
  {
    slug: '/artigo/seguranca-em-compras-internacionais',
    tag: 'Segurança',
    title: 'Segurança em Compras Internacionais: Como o HoobuySpreadsheet Protege Você',
    excerpt: 'Descubra como o Hoobuy Spreadsheet garante a segurança nas suas compras. Proteção contra fraudes e links verificados.',
    imageUrl: 'https://readdy.ai/api/search-image?query=Glass%20shield%20on%20modern%20desk%20next%20to%20laptop%2C%20warm%20ambient%20lighting%2C%20secure%20digital%20concept%2C%20clean%20corporate%20aesthetic%2C%20trust%20theme%2C%20minimal%20photography&width=800&height=500&seq=gdc-seguranca&orientation=landscape'
  },
  {
    slug: '/artigo/categorias-mais-populares-hoobuy',
    tag: 'Tendências',
    title: 'Categorias Mais Populares do Hoobuy: O Que Está Bombando em 2026',
    excerpt: 'Conheça as categorias mais acessadas do Hoobuy Spreadsheet. Descubra quais produtos estão em alta e onde estão as melhores ofertas.',
    imageUrl: 'https://readdy.ai/api/search-image?query=Colorful%20fashion%20items%20on%20white%20surface%20in%20neat%20grid%2C%20shoes%20hoodies%20caps%20organized%2C%20bright%20lighting%2C%20top%20view%2C%20clean%20product%20photography&width=800&height=500&seq=gdc-categorias&orientation=landscape'
  },
  {
    slug: '/artigo/dicas-para-compras-online-2026',
    tag: 'Guia Prático',
    title: '10 Dicas Essenciais para Compras Online com o HoobuySpreadsheet',
    excerpt: 'Confira 10 dicas práticas para fazer compras online com inteligência. Maximize sua economia e evite erros comuns.',
    imageUrl: 'https://readdy.ai/api/search-image?query=Person%20using%20smartphone%20and%20laptop%20at%20cozy%20cafe%2C%20shopping%20online%2C%20warm%20interior%20lighting%2C%20modern%20lifestyle%2C%20relaxed%20atmosphere&width=800&height=500&seq=gdc-dicas&orientation=landscape'
  },
  {
    slug: '/artigo/atualizacoes-hoobuyspreadsheet',
    tag: 'Novidades',
    title: 'Atualizações do HoobuySpreadsheet em 2026: O Que Mudou e Melhorou',
    excerpt: 'Fique por dentro de todas as melhorias do Hoobuy Spreadsheet. Novas funcionalidades e mais segurança para suas compras.',
    imageUrl: 'https://readdy.ai/api/search-image?query=Modern%20spreadsheet%20on%20large%20monitor%20with%20colorful%20data%2C%20minimal%20desk%20with%20plant%2C%20bright%20workspace%2C%20tech%20startup%20vibe%2C%20clean%20office&width=800&height=500&seq=gdc-atualizacoes&orientation=landscape'
  },
  {
    slug: '/artigo/como-encontrar-melhores-ofertas',
    tag: 'Ofertas',
    title: 'Como Encontrar as Melhores Ofertas Usando o HoobuySpreadsheet',
    excerpt: 'Aprenda técnicas avançadas para encontrar as melhores ofertas. Dicas de especialistas para pagar menos em produtos importados.',
    imageUrl: 'https://readdy.ai/api/search-image?query=Magnifying%20glass%20over%20spreadsheet%20with%20highlighted%20prices%2C%20coins%20and%20calculator%2C%20warm%20lamp%20light%2C%20savings%20concept&width=800&height=500&seq=gdc-ofertas&orientation=landscape'
  },
  {
    slug: '/artigo/tutorial-hoobuyspreadsheet-iniciantes',
    tag: 'Tutorial',
    title: 'Tutorial HoobuySpreadsheet para Iniciantes: Guia Passo a Passo',
    excerpt: 'Tutorial completo para iniciantes. Aprenda do zero como navegar, buscar produtos e fazer sua primeira compra com segurança.',
    imageUrl: 'https://readdy.ai/api/search-image?query=Laptop%20with%20beginner%20spreadsheet%20tutorial%2C%20notebook%20and%20pen%2C%20warm%20desk%20lamp%2C%20cozy%20learning%20environment%2C%20step%20by%20step%20guide%20aesthetic&width=800&height=500&seq=gdc-tutorial&orientation=landscape'
  },
  {
    slug: '/artigo/beneficios-planilha-inteligente',
    tag: 'Benefícios',
    title: 'Benefícios da Planilha Inteligente: Por que o HoobuySpreadsheet é Essencial',
    excerpt: 'Descubra todos os benefícios de usar uma planilha inteligente. Economia, segurança, organização e muito mais para 2026.',
    imageUrl: 'https://readdy.ai/api/search-image?query=Neatly%20arranged%20receipts%20and%20product%20photos%20on%20minimal%20white%20desk%2C%20laptop%20with%20checklist%2C%20morning%20light%2C%20satisfaction%20theme%2C%20clean%20photography&width=800&height=500&seq=gdc-beneficios&orientation=landscape'
  }
];

export default function GuiaDeComprasPage() {
  return (
    <main className="min-h-screen bg-background-50">
      <CollectionPageJsonLd />
      <Navbar />

      {/* Hero */}
      <section className="relative pt-24 pb-12 md:pt-32 md:pb-16 px-4 md:px-8 bg-background-50">
        <div className="max-w-4xl mx-auto text-center">
          <a
            href="/"
            className="inline-flex items-center gap-2 text-primary-500 text-sm font-medium mb-6 hover:gap-3 transition-all cursor-pointer whitespace-nowrap"
          >
            <i className="ri-arrow-left-line w-4 h-4 flex items-center justify-center"></i>
            Voltar para página inicial
          </a>
          <span className="inline-block px-4 py-1.5 rounded-full bg-accent-100 text-accent-800 text-xs font-semibold mb-4 whitespace-nowrap">
            Artigos & Guias &bull; 2026
          </span>
          <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-foreground-900 leading-tight mb-4">
            Guia de Compras
          </h1>
          <p className="text-foreground-500 text-base md:text-lg leading-relaxed max-w-2xl mx-auto">
            Conteúdo original e otimizado sobre o <strong>HoobuySpreadsheet</strong>. Guias, tutoriais, dicas e comparações para você comprar melhor e com segurança em 2026.
          </p>
        </div>
      </section>

      {/* Articles Grid */}
      <section className="relative py-8 md:py-12 px-4 md:px-8 bg-background-100">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
            {allArticles.map((article, idx) => (
              <a
                key={idx}
                href={article.slug}
                className="group flex flex-col bg-background-50 rounded-2xl overflow-hidden cursor-pointer transition-all duration-300 hover:-translate-y-1"
              >
                <div className="relative w-full aspect-[16/10] overflow-hidden">
                  <img
                    src={article.imageUrl}
                    alt={article.title}
                    title={article.title}
                    className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                    loading="lazy"
                  />
                </div>
                <div className="flex-1 p-5 flex flex-col">
                  <span className="inline-block px-3 py-1 rounded-full bg-accent-100 text-accent-800 text-xs font-semibold mb-3 whitespace-nowrap w-fit">
                    {article.tag}
                  </span>
                  <h3 className="font-heading text-lg font-semibold text-foreground-900 leading-snug mb-2 group-hover:text-primary-500 transition-colors">
                    {article.title}
                  </h3>
                  <p className="text-foreground-500 text-sm leading-relaxed mb-4 flex-1">
                    {article.excerpt}
                  </p>
                  <span className="inline-flex items-center gap-2 text-primary-500 font-medium text-sm whitespace-nowrap group-hover:gap-3 transition-all mt-auto">
                    Ler artigo
                    <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center"></i>
                  </span>
                </div>
              </a>
            ))}
          </div>
        </div>
      </section>

      {/* Bottom CTA */}
      <section className="relative py-14 md:py-20 px-4 md:px-8 bg-background-50">
        <div className="max-w-3xl mx-auto text-center">
          <div className="p-8 md:p-10 rounded-3xl bg-primary-500">
            <h2 className="font-heading text-2xl md:text-3xl font-semibold text-background-50 mb-3">
              Pronto para Economizar?
            </h2>
            <p className="text-background-100 mb-6 leading-relaxed max-w-md mx-auto">
              Acesse agora o Hoobuy Spreadsheet e comece a transformar sua experiência de compra.
            </p>
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center gap-2 px-7 py-3.5 rounded-full bg-background-50 text-primary-600 font-semibold text-sm cursor-pointer whitespace-nowrap hover:bg-accent-300 transition-all duration-200"
            >
              Acessar HoobuySpreadsheet
              <i className="ri-arrow-right-up-line w-5 h-5 flex items-center justify-center"></i>
            </a>
          </div>
        </div>
      </section>

      <Footer />
    </main>
  );
}